import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=3c45fd8c&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=3c45fd8c&prod&scoped=true&lang=css"
import style1 from "./Address.vue?vue&type=style&index=1&id=3c45fd8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45fd8c",
  null
  
)

export default component.exports